/**
 * <StudentGameSummarySkeleton> — la forme du résumé du jeu pendant le chargement de l'accueil.
 *
 * La carte de la quête puis la ligne du rang : les deux formes sont celles de `<QuestCard>` et de
 * la ligne de `<StudentGameSummary>`, importées et non recopiées.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { QuestCardSkeleton } from "../QuestCard"
import { SUMMARY_LINE_HEIGHT } from "./StudentGameSummary"

export function StudentGameSummarySkeleton() {
    return (
        <Stack gap="2">
            <QuestCardSkeleton />
            <Row style={styles.line}>
                <Skeleton textSize="text-md" width={170} />
            </Row>
        </Stack>
    )
}

const styles = StyleSheet.create((theme) => ({
    line: { minHeight: SUMMARY_LINE_HEIGHT, paddingHorizontal: theme.spacing["4"] },
}))
